var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocalAdminsFullyEnforcedCs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 30,
    viewBox: "0 0 21 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "sva6h3uwaa",
    d: "M0 0h12.5v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.93)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "7y97lxx76b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sva6h3uwaa"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m9.015 5.958 1.2-2.421 1.2 2.421h-2.4zM7.256 12.59l1.262.147c.31.042.435.421.207.632l-.93.884c-.063.042-.084.126-.063.21l.248 1.264c.062.294-.269.547-.517.379l-1.097-.632a.185.185 0 0 0-.207 0l-1.097.632a.352.352 0 0 1-.517-.38l.248-1.263c.02-.084 0-.147-.062-.21l-.973-.884a.367.367 0 0 1 .207-.632l1.263-.147c.082 0 .145-.064.165-.127l.518-1.179a.353.353 0 0 1 .641 0l.518 1.18c.062.062.124.126.186.126zM3.469 5.958H1.068l1.2-2.421 1.2 2.421zm8.961.147-1.863-3.747a.432.432 0 0 0-.33-.232l-2.526.021a1.599 1.599 0 0 0-.703-.863V.78A.77.77 0 0 0 6.242 0a.77.77 0 0 0-.766.779v.484c-.331.19-.58.505-.704.863l-2.524-.02a.432.432 0 0 0-.332.23L.054 6.085c-.062.106-.062.232-.042.358.31 1.158 1.2 1.916 2.256 1.916 1.056 0 1.925-.758 2.256-1.916a.44.44 0 0 0-.041-.358l-1.45-2.926 1.74.02c.123.359.372.654.703.843v4.505c-.58.653-1.8 1.642-4.119 1.895a.406.406 0 0 0-.351.4v2.358c0 4.084 4.863 6.674 5.07 6.779.062.02.124.042.186.042a.384.384 0 0 0 .166-.042c.207-.105 5.07-2.695 5.07-6.78v-2.357a.39.39 0 0 0-.351-.4c-2.318-.232-3.54-1.242-4.119-1.895V4.042c.332-.19.58-.484.704-.842l1.739-.02-1.45 2.925c-.061.106-.061.232-.04.358.31 1.158 1.2 1.916 2.255 1.916 1.056 0 1.946-.758 2.256-1.916a.532.532 0 0 0-.062-.358z",
    fill: "#AEB3B7",
    mask: "url(#7y97lxx76b)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalAdminsFullyEnforcedCs);
export default __webpack_public_path__ + "static/media/local-admins-fully-enforced-cs.306078c1.svg";
export { ForwardRef as ReactComponent };